module.exports = __webpack_public_path__ + "static/media/YB5F12_8.ff437a54.jpg";